import { render, staticRenderFns } from "./SelectBase.vue?vue&type=template&id=6969667c&"
import script from "./SelectBase.vue?vue&type=script&lang=js&"
export * from "./SelectBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports